// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Tooltip, ANIMATION} from '@pub/comp/tooltip';
import * as cns from './popover.module.less';

const TRIGGERS = ['click'];
const CLASSNAMES = {root: cns.root, body: cns.inner};

export function Popover({content, children, placement='top'}){
    if (!content)
        return children;
    return <Tooltip tip={content} trigger={TRIGGERS} animation={ANIMATION.NOPE}
      show_delay_s={0} classnames={CLASSNAMES} placement={placement}
      destroyOnHide>
      {children}
    </Tooltip>;
}
